<template>
    <div class="row">
        <div class="col-lg-6 text-right">
            <div class="_education my-3" v-if="user.education.length > 0">
                <h4 class="font-weight-bold"> Educación</h4>
                <ul class="list-unstyled">
                    <li v-for="(item, key) in user.education" :key="key">

                        {{item.institucion}}
                        <div class="ml-4">{{item.ano_inicio + ' - ' + item.ano_fin}}</div>
                    </li>
                </ul>
            </div>
            <div class="_skill my-3" v-if="user.skill.length > 0">
                <h4 class="font-weight-bold"> Habilidades</h4>
                <li class="list-unstyled" v-for="(item, key) in user.skill" :key="key">{{item.habilidad}}</li>
            </div>
            <div class="_software my-3" v-if="user.software.length > 0">
                <h4 class="font-weight-bold"> Software</h4>
                <li class="list-unstyled" v-for="(item, key) in user.software" :key="key">{{item.software}}</li>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="_experience my-3" v-if="user.experience.length > 0">
                <h4 class="font-weight-bold">  Experiencia Laboral</h4>
                <li class="list-unstyled" v-for="(item, key) in user.experience" :key="key">
                    {{item.puesto}}
                    <div class="_enterprise ml-4">{{item.empresa}}</div>
                    <div class="_location ml-4">{{item.descripcion}}</div>
                </li>
            </div>
            <div class="_project my-3" v-if="user.project.length > 0">
                <h4 class="font-weight-bold"> Proyectos y publicaciones</h4>
                <li class="list-unstyled" v-for="(item, key) in user.project" :key="key">
                    <div class="_projectname">{{item.nombre}}{{item.ano_fin ? '/' + item.mes + ' ' + item.ano_fin : ''}}</div>
                    <div class="_enterprise ml-4">{{item.emisor}}</div>
                    <div class="_location ml-4">{{item.tipo}}</div>
                </li>
            </div>
            <div class="_achievement my-3" v-if="user.achievement.length > 0">
                <h4 class="font-weight-bold"> Logros y reconocimientos</h4>
                <li class="list-unstyled" v-for="(item, key) in user.achievement" :key="key">
                    <div class="_projectname">{{item.nombre}}</div>
                    <div class="_enterprise ml-4">{{item.funcion_desempenada}}</div>
                    <div class="_location ml-4">{{item.academico}}</div>
                </li>
            </div>
            <div class="_service" v-if="user.service.length > 0">
                <h4 class="font-weight-bold">Servicio y voluntariado</h4>
                <li class="list-unstyled" v-for="(item, key) in user.service" :key="key">
                    <div class="_projectname">{{item.organizacion}}</div>
                    <div class="_enterprise ml-4">{{item.funcion_desempenada}}</div>
                    <div class="_location ml-4">{{item.ano_inicio + ' - ' + item.ano_fin}}</div>
                </li>
            </div>
        </div>
    </div>
</template>
<style scoped>
    *{ font-size: 10px !important; }
</style>
<script>
export default {
    props:{
        user: Object
    },
    data() {
        return {

        }
    },
    created() {

    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/components/CurriculumPreview.vue